module.exports = __webpack_public_path__ + "r-v3/img/trash.664a2710.svg";